import { appCode } from '../../config';
import { ROUTES, CB_ROUTES } from '../const/routes';
import { INTENT_MANAGER_ROUTES } from '../const/intentManager';
import ConversationAssistRoutes from '../components/conversation-assist/router/routes';

// use this approach to split the code of a component, and bundle it as a separate chunk that is loaded lazily
const LandingPage = () => import('@/components/LandingPage');
const BotPlatform = () => import('@/components/iframes/BotPlatform');
const ConvBuilder = () => import('@/components/iframes/ConvBuilder');
const IntentManager = () => import('@/components/intent-manager/IntentManager');
// Intent Manager routes
const LiveIntent = () => import('@/components/iframes/LiveIntent');
const IntentAnnotator = () => import('@/components/iframes/IntentAnnotator');
const IntentBuilder = () => import('@/components/iframes/IntentBuilder');
const PerformanceOptimizer = () => import('@/components/iframes/PerformanceOptimizer');
const DataTransporter = () => import('@/components/iframes/DataTransporter');
const AiWorkbench = () => import('@/components/iframes/AiWorkbench');

export default [
  {
    path: `/${appCode}/${ROUTES.LANDING}`,
    name: ROUTES.LANDING,
    components: { [appCode]: LandingPage },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: '',
    },
  },
  {
    path: `/${appCode}/${ROUTES.BOT_PLATFORM}`,
    name: ROUTES.BOT_PLATFORM,
    components: { [appCode]: BotPlatform },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.botplatform',
    },
  },
  {
    path: `/${appCode}/${ROUTES.AIWB}`,
    name: ROUTES.AIWB,
    components: { [appCode]: AiWorkbench },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.botplatform',
    },
  },
  { ...ConversationAssistRoutes },
  {
    path: `/${appCode}/${ROUTES.PERFORMANCE_OPTIMIZER}`,
    name: ROUTES.PERFORMANCE_OPTIMIZER,
    components: { [appCode]: PerformanceOptimizer },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.performanceoptimizer',
    },
  },
  {
    path: `/${appCode}/${ROUTES.DATA_TRANSPORTER}`,
    name: ROUTES.DATA_TRANSPORTER,
    components: { [appCode]: DataTransporter },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.datatransporter',
    },
  },
  {
    path: `/${appCode}/${ROUTES.INTENT_MANAGER}`,
    name: ROUTES.INTENT_MANAGER,
    components: { [appCode]: IntentManager },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.liveintent',
    },
    children: [
      {
        name: INTENT_MANAGER_ROUTES.INTENT_MANAGER,
        path: '',
        components: {
          iframe: LiveIntent,
        },
      },
      {
        name: INTENT_MANAGER_ROUTES.ANALYZE,
        path: 'analyze',
        components: {
          iframe: LiveIntent,
        },
      },
      {
        name: INTENT_MANAGER_ROUTES.DISCOVER,
        path: 'discover',
        components: {
          iframe: LiveIntent,
        },
      },
      {
        name: INTENT_MANAGER_ROUTES.BUILD,
        path: 'build',
        components: {
          iframe: IntentBuilder,
        },
      },
      {
        name: INTENT_MANAGER_ROUTES.DOMAIN_SETTINGS,
        path: 'build/settings',
        components: {
          iframe: IntentBuilder,
        },
      },
      {
        name: INTENT_MANAGER_ROUTES.OPTIMIZE,
        path: 'optimize',
        components: {
          iframe: IntentAnnotator,
        },
      },
      {
        path: '*', redirect: { name: INTENT_MANAGER_ROUTES.INTENT_MANAGER },
      },
    ],
  },
  // CB routes
  {
    path: `/${appCode}/${CB_ROUTES.BOT_BUILDER}`,
    name: CB_ROUTES.BOT_BUILDER,
    components: { [appCode]: ConvBuilder },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.botbuilder',
    },
  },
  {
    path: `/${appCode}/${CB_ROUTES.KNOWLEDGE_BASE}`,
    name: CB_ROUTES.KNOWLEDGE_BASE,
    components: { [appCode]: ConvBuilder },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.knowledgebase',
    },
  },
  {
    path: `/${appCode}/${CB_ROUTES.DOMAINS}`,
    name: CB_ROUTES.DOMAINS,
    components: { [appCode]: ConvBuilder },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.domains',
    },
  },
  {
    path: `/${appCode}/${CB_ROUTES.ANALYTICS}`,
    name: CB_ROUTES.ANALYTICS,
    components: { [appCode]: ConvBuilder },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.analytics',
    },
  },
  {
    path: `/${appCode}/${CB_ROUTES.SYS_ADMIN}`,
    name: CB_ROUTES.SYS_ADMIN,
    components: { [appCode]: ConvBuilder },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.sysadmin',
    },
  },
  {
    path: `/${appCode}/${CB_ROUTES.ORG_MGMT}`,
    name: CB_ROUTES.ORG_MGMT,
    components: { [appCode]: ConvBuilder },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.orgmgmt',
    },
  },
  {
    path: `/${appCode}*`,
    name: 'default',
    redirect: { path: `/${appCode}/${ROUTES.LANDING}` },
  },
];
